"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTab = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const FileDisplay_1 = require("./FileDisplay");
const Wrapper = styled_1.default(react_core_1.ButtonBase) `
  color: ${react_core_1.ifProp('selected', react_core_1.prop('theme.gray0'), react_core_1.prop('theme.gray2'))};
  background-color: ${react_core_1.ifProp('selected', react_core_1.prop('theme.lightBlack'), react_core_1.prop('theme.gray5'))};
  ${react_core_1.prop('theme.fontStyles.body1')};
  padding: 8px;
  cursor: pointer;
  ${react_core_1.ifProp('first', '', react_core_1.withProp('theme.lightBlack', (color) => `border-left: 2px solid ${color}`))};
  outline: none;
  white-space: nowrap;
`;
exports.FileTab = (_a) => {
    var { first, file, selected, omitReadOnly } = _a, props = tslib_1.__rest(_a, ["first", "file", "selected", "omitReadOnly"]);
    return (React.createElement(Wrapper, Object.assign({ first: first, selected: selected }, props),
        React.createElement(FileDisplay_1.FileDisplay, { file: file, omitReadOnly: omitReadOnly })));
};

//# sourceMappingURL=FileTab.js.map
